import {SecureService} from "@/services/superclasses/secure-service";

const api = window.contextPath + '/rest/production-unit-numbers';

export class ProductionUnitNumberSecureService extends SecureService {

    public loadByMember = async (): Promise<string[]> => {
        return this.data(await this.get<string[]>(api + "/by-member"));
    }
}

export const productionUnitNumberSecureService = new ProductionUnitNumberSecureService()